import {analyticsLogger} from 'analytics/analyticsLogger';

/** Bare-bones detail-page mutations: use `WORKSTREAM_MODIFIED` + stable dimensions. */
export function logWorkstreamDetailModified(payload: {
  workstream_id: number;
  property: string;
  type?: string;
  role?: string;
}) {
  analyticsLogger().logEvent('WORKSTREAM_MODIFIED', {
    source: 'workstream_details',
    ...payload,
  });
}
